import React, { memo, forwardRef } from "react";
const SvgCapitalN = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12.32 13.02h-.04v8.82c0 .307-.047.553-.14.74a1.347 1.347 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.274.06-.38.06-.107 0-.234-.02-.38-.06a.938.938 0 01-.42-.2 1.517 1.517 0 01-.32-.42c-.094-.187-.14-.433-.14-.74V10.58c0-.387.06-.7.18-.94s.26-.427.42-.56a1.36 1.36 0 01.52-.26c.186-.053.34-.08.46-.08.28 0 .56.08.84.24.28.147.586.453.92.92l6.58 9.06h.04v-8.8c0-.293.046-.533.14-.72.093-.187.2-.333.32-.44a.938.938 0 01.42-.2c.146-.04.273-.06.38-.06.106 0 .233.02.38.06.146.027.28.093.4.2.133.107.246.253.34.44.093.187.14.427.14.72v11.26c0 .387-.06.7-.18.94s-.267.427-.44.56c-.16.133-.334.22-.52.26-.174.053-.32.08-.44.08-.294 0-.574-.073-.84-.22-.267-.16-.574-.473-.92-.94l-6.58-9.08z"
      />
    </svg>
  );
});
SvgCapitalN.displayName = "SvgCapitalN";
const MemoForwardRef = memo(SvgCapitalN);
export default MemoForwardRef;
